export default "__VITE_ASSET__rWqyjORc__"